module.exports = __webpack_public_path__ + "static/media/media-blue.d4fc6c27.svg";